import React, { useEffect, useState } from "react";
import { DownloadSimple, X, Export } from "@phosphor-icons/react";

const DISMISS_KEY = "eq_install_dismissed";
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (Date.now() - dismissed < 14 * 24 * 3600 * 1000) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIos()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); setShow(false); };
  const install = async () => {
    try { deferred.prompt(); await deferred.userChoice; } catch { /* user cancelled */ }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div data-testid="install-prompt"
      className="fixed bottom-0 inset-x-0 z-50 bg-equipr-black text-white px-4 py-3 flex items-center gap-3 border-t-2 border-equipr-yellow">
      <DownloadSimple size={22} weight="bold" className="text-equipr-yellow shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold leading-tight">Install EQUIPR on this device</p>
        <p className="text-[11px] text-gray-300 leading-tight mt-0.5">
          {deferred
            ? "Works offline on site — dockets, diary & sign-in."
            : <>Tap <Export size={11} className="inline" weight="bold" /> Share, then &ldquo;Add to Home Screen&rdquo; — works offline on site.</>}
        </p>
      </div>
      {deferred && (
        <button onClick={install} data-testid="install-prompt-btn"
          className="h-9 px-4 bg-equipr-yellow text-equipr-black text-sm font-bold rounded-none shrink-0 hover:bg-equipr-yellow-dark">
          Install
        </button>
      )}
      <button onClick={dismiss} data-testid="install-prompt-dismiss" aria-label="Dismiss"
        className="text-gray-400 hover:text-white shrink-0">
        <X size={18} weight="bold" />
      </button>
    </div>
  );
}
